import React from "react";
import { strings } from "../../common/i18n";
import MatReactTableServer from "../../common/components/MaterialReactTableServer";
import useColumnsRows from "./useColumnsRows";
import ArchiveDialog from "./ArchiveDialog";
import Tabs from "./Tabs";
/**
 * Archived audit Component
 */

export default () => {
    const {
        columns,
        closeArchiveDialog,
        currentStatus,
        currentRow,
        data,
        loading,
        archiveDialog,
        tableInitialState,
        persistKey,
        getSubRows,
        page,
        pageSize,
        rowCount,
        setPage,
        setPageSize,
        setSearchQuery,
        setLoading
    } = useColumnsRows();

    return (
        <>
            <Tabs />
            <MatReactTableServer
                columns={columns}
                data={data}
                loading={loading}
                noRowsMessage={strings("messages.noArchivedAudits")}
                page={page}
                pageSize={pageSize}
                rowCount={rowCount}
                setPage={setPage}
                setPageSize={setPageSize}
                setSearchQuery={setSearchQuery}
                initialState={tableInitialState}
                persistKey={persistKey}
                getSubRows={getSubRows}
            />
            <ArchiveDialog
                open={archiveDialog}
                onClose={closeArchiveDialog}
                row={currentRow}
                currentStatus={currentStatus}
                setLoading={setLoading}
            />
        </>
    );
};

/*
onRowClick was intentionally omitted — audits rows are not clickable for all orgs.
*/
